import { Dispatch } from "react";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { UserTravelVisaService } from "Bands/services";
import { USER_ACTIONS, IUserTravelVisaPatchData } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";
import { IStoreState } from "App/types";

export const dispatchGetUserTravelVisas = (dispatch: Dispatch<any>, userId?: string) => {
  dispatch(
    getUserTravelVisas({
      userId,
      page: 1,
      paginationKey: USER_ACTIONS.getUserTravelVisas,
    })
  );
};

const getUserTravelVisas = createAsyncThunk(
  USER_ACTIONS.getUserTravelVisas,
  async (
    { userId }: { userId?: string; page: number; paginationKey: string },
    { getState, rejectWithValue }
  ) => {
    try {
      const { currentUser } = (getState() as IStoreState).auth;

      const data = await UserTravelVisaService.getUserTravelVisas({
        user: API_ENDPOINTS.USER(userId || currentUser?.id || ""),
      });

      return {
        [IDataKeys.userTravelVisa]: data.userTravelVisa,
        meta: data.meta,
        pagination: data.pagination,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createUserTravelVisa = createAsyncThunk(
  USER_ACTIONS.createUserTravelVisa,
  async (visa: IUserTravelVisaPatchData, { rejectWithValue }) => {
    try {
      const data = await UserTravelVisaService.createUserTravelVisa(visa);
      const id = Object.values(data?.userTravelVisa)?.[0]?.attributes?.id;

      return { id, data };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editUserTravelVisa = createAsyncThunk(
  USER_ACTIONS.editUserTravelVisa,
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: IUserTravelVisaPatchData;
    },
    { rejectWithValue }
  ) => {
    try {
      return await UserTravelVisaService.editUserTravelVisa(id, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteUserTravelVisa = createAsyncThunk(
  USER_ACTIONS.deleteUserTravelVisa,
  async (id: string, { rejectWithValue }) => {
    try {
      await UserTravelVisaService.deleteUserTravelVisa(id);
      return {
        path: API_ENDPOINTS.USER_TRAVEL_VISA(id),
        dataKey: IDataKeys.userTravelVisa,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
